import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Pure Pwnage is the best show ever",
  "description": "",
  "published": "2010-03-22T00:00:00.000Z",
  "redirect_from": ["/blog/pure-pwnage-is-the-best-show-ever/swizec/1258"],
  "categories": "Canada, Games, intrigues, life, Pure Pwnage, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://en.wikipedia.org/wiki/Image:Purepwnage.jpg"
          }}><img parentName="a" {...{
              "src": "https://swizec.com/blog/wp-content/uploads/2010/03/300px-Purepwnage.jpg",
              "alt": "Pure Pwnage",
              "title": "Pure Pwnage"
            }}></img></a></p>
        <p parentName="li">{`Image via `}<a parentName="p" {...{
            "href": "http://en.wikipedia.org/wiki/Image:Purepwnage.jpg"
          }}>{`Wikipedia`}</a></p>
      </li>
    </ul>
    <p>{`Hai guise, long time no funky and interesting posting around here.`}</p>
    <p>{`That's all about to change.`}</p>
    <p>{`'Cause I've got something incredibly awesome and silly to tell all y'all.`}</p>
    <p>{`Remember `}<a parentName="p" {...{
        "href": "http://www.purepwnage.com",
        "title": "Pure Pwnage"
      }}>{`Pure Pwnage`}</a>{`? That show about a gaming dude called Jeremy otherwise known as `}{`_`}{`teh_pwnerer `}{`_`}{`who is followed around by his `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Newbie",
        "title": "Newbie"
      }}>{`noob`}</a>{` brother Kyle and they make a show?`}</p>
    <p>{`Yeah that one, the best fucking internet show ever devised by man. I loved that damn thing!`}</p>
    <p>{`But then it sort of died, with T-Bone's crash and everything. It also just so happened to `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Jumping_the_shark",
        "title": "Jumping the shark"
      }}>{`jump the shark`}</a>{` a little bit even before then. It was much awesomer when everyone still believed Jeremy was Jeremy and Kyle was Kyle and so on. Seriously, it looked totally legit.`}</p>
    <p>{`Thing was, once they published that they were professionals, alright, doesn't hurt the show and Jeremy was still a pretty heavy `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Gamer",
        "title": "Gamer"
      }}>{`gamer`}</a>{` IRL anyway. I mean they had to be to know that many jokes about games. Thing was, they suddenly felt the freedom of not having to be constrained by reality and it degraded the quality a bit.`}</p>
    <p>{`BUT NO MATTER!`}</p>
    <p>{`Because NOW, oh yeas, yes!, NOW they're back! And.`}</p>
    <p>{`it.`}</p>
    <p>{`is.`}</p>
    <p>{`fucking.`}</p>
    <p>{`awesome!`}</p>
    <p>{`They finally managed to become a proper TV show so the quality of everything is a bit better, but they've retained the good old format of behind-the-camera Kyle and Jeremy his brother and so on. I watched the season premiere last night and I recommend anyone and everyone who's ever played a video game to go download it and give it a good watch.`}</p>
    <p>{`Unfortunately, yeah, with becoming more proper they've also become moronic about copyright. In the old days you could just go to their site and watch it anywhere in the world. They had a huge worldwide fanbase and they really really took care of us fans methinks. Now you can only watch it from Canada and US or something. A huge waste.`}</p>
    <p>{`They basically threw away the one thing that made them really popular and successful - openness. But oh well, at least there's piratebay and such.`}</p>
    <h6 {...{
      "id": "related-articles-by-zemanta"
    }}>{`Related articles by Zemanta`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.nationalpost.com/rss/story.html?id=2667931"
        }}>{`Pure Pwnage: This is what the nerds' revenge looks like`}</a>{` (nationalpost.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://reblog.zemanta.com/zemified/d7ffe976-02e2-41e5-b2d3-79a66ad853bb/",
        "title": "Reblog this post [with Zemanta]"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/reblog_e.png?x-id=d7ffe976-02e2-41e5-b2d3-79a66ad853bb",
          "alt": "Reblog this post [with Zemanta]"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      